export class AddScanICourrier {
  lotGuid: string;
  filename: string;
  uploadDate: Date;
  scanType: string;
  pagesCount: number;
}
